export const COMPANY_TIME_ZONE = "America/Toronto";

const formatterCache = new Map();

const getFormatter = (options) => {
  const cacheKey = JSON.stringify(options);
  if (!formatterCache.has(cacheKey)) {
    formatterCache.set(cacheKey, new Intl.DateTimeFormat("en-CA", { timeZone: COMPANY_TIME_ZONE, ...options }));
  }
  return formatterCache.get(cacheKey);
};

const getDateParts = (value, options) => {
  const date = value instanceof Date ? value : new Date(value);
  return getFormatter(options).formatToParts(date).reduce((parts, item) => {
    if (item.type !== "literal") {
      parts[item.type] = item.value;
    }
    return parts;
  }, {});
};

const getOffsetMs = (date) => {
  const parts = getDateParts(date, {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
    hourCycle: "h23",
  });
  const zonedTimestamp = Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day), Number(parts.hour), Number(parts.minute), Number(parts.second));
  return zonedTimestamp - date.getTime();
};

export const formatDateTime = (value) => {
  if (!value) {
    return "—";
  }
  return getFormatter({
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  }).format(new Date(value));
};

export const toInputDateTime = (value) => {
  if (!value) {
    return "";
  }
  const parts = getDateParts(value, {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
    hourCycle: "h23",
  });
  return `${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}`;
};

export const formatInputTimePreview = (value) => {
  if (!value) {
    return "";
  }
  const [, timePart = ""] = value.split("T");
  const [hourValue, minuteValue = "00"] = timePart.split(":");
  const hour = Number(hourValue);
  if (Number.isNaN(hour)) {
    return "";
  }
  const suffix = hour >= 12 ? "PM" : "AM";
  const normalizedHour = hour % 12 || 12;
  return `${normalizedHour}:${minuteValue} ${suffix}`;
};

export const toIsoString = (value) => {
  if (!value) {
    return "";
  }
  const [datePart, timePart = "00:00"] = value.split("T");
  const [year, month, day] = datePart.split("-").map(Number);
  const [hour, minute] = timePart.split(":").map(Number);
  const utcGuess = new Date(Date.UTC(year, month - 1, day, hour, minute, 0));
  const firstOffset = getOffsetMs(utcGuess);
  let zonedDate = new Date(utcGuess.getTime() - firstOffset);
  const adjustedOffset = getOffsetMs(zonedDate);
  if (adjustedOffset !== firstOffset) {
    zonedDate = new Date(utcGuess.getTime() - adjustedOffset);
  }
  return zonedDate.toISOString();
};